"use strict";

exports.__esModule = true;
exports.default = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = {
  "ui:layout": "primusModule",
  "ui:options": {
    "editable": true,
    "orderable": false
  },
  "ui:preview": {
    "select": {
      "documentType": "documentType",
      "title": "title",
      "description": "description",
      "conditionId": "conditionId",
      "priorityId": "priorityId",
      "label": "label",
      "status": "status"
    },

    prepare({
      formData
    }) {
      const documentType = formData.documentType;
      const documentTypes = {
        "damage": "Avvik",
        "condition": "Tilstand",
        "task": "Oppgave",
        "work": "Bygningsarbeid"
      };
      const label = documentTypes[documentType];
      return _extends({}, formData, {
        label: label
      });
    }

  }
};
exports.default = _default;
module.exports = exports.default;